import store from '@store';
import toast from '@utils/toast';
// Create a simple Vue plugin to expose the wrapper object throughout the application

export const LogOutPlugin = {
  install(Vue, options) {
    Vue.prototype.$logOut = function() {
      this.request('/logout', 'POST', {}).then((response) => {
        if (response.code === 0) {
        } else {
          toast.errorMessage(response.message);
        }
      }).catch((error) => {
        toast.errorMessage(error.message);
      }).finally(() => {
        toast.logout();
        store.dispatch('logout');
        this.toggleMenu(false);
        setTimeout(() => {
          this.$auth.logout({
            logoutParams: {
              returnTo: process.env.VUE_APP_LOGOUT_REDIRECT
            }
          });
        }, 2000);
      });
    };
  }
};
